import { useEffect, useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { FileWarning } from "lucide-react";
import { Api } from "../../Utils/AxiosBiometria";
import {
  Alert,
  Button,
  Card,
  Col,
  ProgressBar,
  Row,
  Spinner,
} from "react-bootstrap";

export function RedirectLink() {
  const [error, setError] = useState(null);
  const params = useParams();

  const getValidLink = useCallback(async ({ hash }) => {
    try {
      const response = await Api.get(`/biometria/redirect/${hash}`);
      if (response) {
        window.location.href = response.data;
      }
    } catch (err) {
      console.log(err.response?.data);
      setError(
        err.response?.data?.message ??
          "Ocorreu um problema com sua validação, entre em contato com a transportadora!",
      );
    }
  }, []);

  useEffect(() => {
    if (params && params?.hash) {
      const timer = setTimeout(() => {
        getValidLink({ hash: params.hash });
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [params, getValidLink]);

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        height: "100vh",
        width: "100vw",
      }}
    >
      <Card
        className="mx-auto card_info"
        style={{
          minHeight: "40vh",
          width: "50vw",
          boxShadow: "0 25px 50px -12px rgba(45,106,79,0.08)",
        }}
      >
        <Row className="text-center p-5 d-flex flex-column align-items-center justify-content-center">
          {!error ? (
            <>
              <Alert
                variant="success"
                className="mx-auto mb-5 border-success rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: "100px",
                  height: "100px",
                }}
              >
                <Spinner
                  role="status"
                  animation="border"
                  variant="success"
                  style={{
                    width: "60px",
                    height: "60px",
                  }}
                />
              </Alert>

              <Col className="text-center">
                <h5 className="title">Validação Facial</h5>
                <p className="subtitle">
                  Aguarde enquanto estamos te redirecionando para a validação.
                </p>
              </Col>

              <Col className="mt-3">
                <ProgressBar
                  variant="success"
                  now={40}
                  className="p-0 rounded-pill"
                  style={{ height: "8px" }}
                />
              </Col>
            </>
          ) : (
            <Col className="d-flex flex-column align-items-center">
              <Alert variant="warning" className="card_info border-warning">
                <FileWarning size={48} className="text-warning" />
              </Alert>

              <h5 className="title">Atenção!</h5>
              <p className="subtitle">{error}</p>

              <Button
                onClick={() =>
                  (window.location.href = "https://flexconsulta.com.br/")
                }
                className="rounded-pill w-100"
              >
                Ok
              </Button>
            </Col>
          )}
        </Row>
      </Card>
    </div>
  );
}
